module.exports = __webpack_public_path__ + "06a71c884c072726fcb37438419d5eaa.svg";